/**
 * WmQtyStepper — custom element handling qty +/- on the cart page.
 * Wraps each .wm-cart-item__qty pill. Uses /cart/change.js to update
 * quantities without a full page reload. Reloads if qty reaches 0.
 */
class WmQtyStepper extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    this.addEventListener('click', this.#handleClick.bind(this));
    this.#syncMinusState();
  }

  #syncMinusState() {
    const input = this.querySelector('input[data-quantity-input]');
    const minusBtn = this.querySelector('[data-action="decrease"]');
    if (!input || !minusBtn) return;
    const qty = parseInt(input.value) || 1;
    minusBtn.disabled = qty <= 1;
  }

  #handleClick(e) {
    const btn = e.target.closest('[data-action]');
    if (!btn || btn.disabled) return;

    e.preventDefault();

    const action = btn.dataset.action;
    const line = btn.dataset.line;
    const input = this.querySelector(`input[data-line="${line}"]`);

    if (!input) return;

    const current = parseInt(input.value) || 0;
    const next = action === 'increase' ? current + 1 : Math.max(1, current - 1);

    input.value = next;
    btn.blur();
    this.#syncMinusState();
    this.#updateCart(parseInt(line), next);
  }

  async #updateCart(line, quantity) {
    this.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });

      if (!response.ok) return;

      const cart = await response.json();

      if (quantity === 0) {
        window.location.reload();
        return;
      }

      // Update item line price
      const cartItem = this.closest('[data-index]');

      if (cartItem) {
        const index = cartItem.dataset.index;
        const lineItem = cart.items[parseInt(index) - 1];

        if (lineItem) {
          const priceEl = cartItem.querySelector('[data-line-price]');
          if (priceEl) priceEl.textContent = this.#formatMoney(lineItem.final_line_price, cart.currency);
        }
      }

      // Update cart totals
      const totalEls = document.querySelectorAll('[data-cart-total], [data-cart-grand-total]');
      for (const el of totalEls) {
        el.textContent = this.#formatMoney(cart.total_price, cart.currency);
      }
    } finally {
      this.removeAttribute('aria-busy');
      this.#syncMinusState();
    }
  }

  #formatMoney(cents, currency) {
    const symbol = currency === 'GBP' ? '£' : currency === 'USD' ? '$' : currency === 'EUR' ? '€' : '';
    const amount = (cents / 100).toFixed(2);
    return `${symbol}${amount}`;
  }
}

customElements.define('wm-qty-stepper', WmQtyStepper);
